/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {fetchAsyncUserDetails} from '../../../../../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
const initialState = {
  userInfo: {},
  onboarding: {
    currentStep: 0,
    isComplete: false,
    questions: [],
    total: 0,
    isFinished: false,
    isLoading: false,
  },
}
const API_URL = ENV().REACT_APP_API_URL

export const UserLoginAuth: any = createAsyncThunk(
  'signIn/UserLoginAuth',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}auth/user/login`, data, {})
    if (Object.keys(response.data?.error).length !== 0) {
      thunkApi?.dispatch(fetchAsyncUserDetails())
    }
    return response.data
  }
)

export const adminLoginAsUser: any = createAsyncThunk(
  'admin/loginAsUser',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}admin/loginAsUser`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    return response.data
  }
)

export const fetchAsyncVerifyOtp: any = createAsyncThunk(
  'verifyOtp/fetchAsyncVerifyOtp',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}auth/verifyotp`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    return response.data
  }
)

export const ssoLogin: any = createAsyncThunk('auth/sso', async (data, thunkApi) => {
  const response = await axios.post(`${API_URL}auth/sso`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  {
    response.data.status == true
      ? toast.success(response.data.message)
      : toast.error(response.data.message)
  }
  return response.data
})

export const fetchAsyncVerifyemailOtp: any = createAsyncThunk(
  'verifyOtp/fetchAsyncVerifyemailOtp',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}auth/verify-email`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data.status == true
        ? toast.success(response.data.message)
        : toast.error(response.data.message)
    }
    thunkApi?.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

export const sendMobileOtp: any = createAsyncThunk('sendMobileOtp', async (data) => {
  const response = await axios.post(`${API_URL}auth/sendOtp`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  response.data?.status && toast.success(response.data.message)
  return response.data
})

export const changeMobileNumber: any = createAsyncThunk('changeMobileNumber', async (data) => {
  const response = await axios.post(`${API_URL}auth/mobile/change-mobile`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data
})

export const verifyMobileOtp: any = createAsyncThunk('verifyMobileOtp', async (data) => {
  const response = await axios.post(`${API_URL}auth/verifyMobileotp`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data
})

export const sendEmailOtp: any = createAsyncThunk('sendEmailOtp', async (data) => {
  const response = await axios.post(`${API_URL}auth/sendEmail`, data, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data
})

export const userOnboarding: any = createAsyncThunk('signIn/onboarding', async (step) => {
  const response = await axios.get(`${API_URL}user/onboarding/questions?step=${step}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  return response.data
})

export const userOnboardingAnswer: any = createAsyncThunk(
  'signIn/onboardingAnswer',
  async (payload) => {
    const response = await axios.post(`${API_URL}user/onboarding/answer`, payload, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    return response.data
  }
)

const UserLoginSlice = createSlice({
  name: 'signIn',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.clear()
      return {...state, userInfo: {}, onboarding: initialState.onboarding}
    },
    EmailVerify: (state, {payload}) => {
      return {...state, userInfo: {...state.userInfo, isEmailVerified: payload}}
    },
    otpVerified: (state, {payload}) => {
      return {...state, userInfo: {...state.userInfo, isOtpVerified: payload}}
    },
    SignupForm: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isAdminAsUser', 'false')

      localStorage.setItem('permission', JSON.stringify(payload?.userPermissions))
      localStorage.setItem('currentUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.user?.role))
      localStorage.setItem('token', payload?.token)
      return {...state, userInfo: {...payload}}
    },
    UpdateLoggedUserInfo: (state, {payload}) => {
      return {...state, userInfo: {...payload}}
    },
    updateOnboardingStatus: (state, {payload}) => {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          isFinished: payload,
        },
      }
    },
  },
  extraReducers: {
    [fetchAsyncVerifyOtp.fulfilled]: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isAdminAsUser', 'false')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('currentUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('firstimeLogin', payload?.data?.user?.firstTimeLogin)
      localStorage.setItem('token', payload.data?.token)

      return {...state, userInfo: payload?.data}
    },

    [ssoLogin.fulfilled]: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isAdminAsUser', 'false')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('currentUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('firstimeLogin', payload?.data?.user?.firstTimeLogin)
      localStorage.setItem('token', payload.data?.token)

      return {...state, userInfo: payload?.data}
    },
    [UserLoginAuth.pending]: (state) => {},
    [UserLoginAuth.fulfilled]: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('firstimeLogin', payload?.data?.user?.firstTimeLogin)
      localStorage.setItem('isAdminAsUser', 'false')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('currentUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('token', payload.data?.token)
      if (payload?.data?.is2FAEnabled) {
        if (!payload?.data?.isMobileVerified && payload?.data?.mobile) {
          return {
            ...state,
            userInfo: {
              otp: true,
              mobile: payload?.data?.mobile,
              email: payload?.data?.email,
              otpType: 'SIGNUP_MOBILE',
            },
          }
        }

        return {
          ...state,
          userInfo: {
            otp: true,
            mobile: payload?.data?.user?.mobile,
            email: payload?.data?.user?.email,
            otpType:
              payload?.data?.user?.otpNotificationType === 'sms' &&
              payload?.data?.user?.isMobileVerified
                ? 'SIGNUP_MOBILE'
                : 'SIGNIN_EMAIL',
          },
        }
      }

      if (payload.data?.mobile != null) {
        payload.data?.isMobileVerified === true
          ? toast.success(payload.message)
          : Object.keys(payload?.error).length < 0 && toast.error('Please verify Your Otp')

        return payload.data?.isMobileVerified === true
          ? {...state, userInfo: payload?.data}
          : {
              ...state,
              userInfo: {
                otp: Object.keys(payload?.error).length === 0,
                mobile: payload?.data?.mobile,
                email: payload?.data?.email,
              },
            }
      }
      return {...state, userInfo: payload?.data}
    },
    [UserLoginAuth.rejected]: () => {},
    [adminLoginAsUser.pending]: (state) => {},
    [adminLoginAsUser.fulfilled]: (state, {payload}) => {
      localStorage.setItem('isAdmin', 'false')
      localStorage.setItem('isAdminAsUser', 'true')
      localStorage.setItem('permission', JSON.stringify(payload?.data?.userPermissions))
      localStorage.setItem('currentUser', JSON.stringify(payload))
      localStorage.setItem('role', JSON.stringify(payload?.data?.user?.role))
      localStorage.setItem('token', payload.data?.token)
      localStorage.setItem('isAdminAsUserRefresh', 'false')

      if (payload.data?.mobile != null) {
        payload.data?.isMobileVerified === true
          ? toast.success(payload.message)
          : Object.keys(payload?.error).length < 0 && toast.error('Please verify Your Otp')
        return payload.data?.isMobileVerified === true
          ? {...state, userInfo: payload?.data}
          : {
              ...state,
              userInfo: {
                otp: Object.keys(payload?.error).length === 0,
                mobile: payload?.data?.mobile,
                email: payload?.data?.email,
              },
            }
      }
      toast.success(payload.message)
      return {...state, userInfo: payload?.data}
    },
    [adminLoginAsUser.rejected]: () => {},
    [userOnboarding.pending]: (state, {payload}) => {
      return {
        ...state,
        onboarding: {
          ...state?.onboarding,
          isLoading: true,
        },
      }
    },
    [userOnboarding.fulfilled]: (state, {payload}) => {
      return {
        ...state,
        onboarding: {
          ...payload?.data,
          isFinished: payload?.data?.isComplete ? true : false,
          currentStep: payload?.data?.step ?? 1,
          isLoading: false,
        },
      }
    },
    [userOnboardingAnswer.fulfilled]: (state, {payload}) => {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          currentStep: payload?.data?.currentStep ?? 1,
          isComplete: payload?.data?.isComplete ?? false,
          isLoading: false,
        },
      }
    },
    [userOnboardingAnswer.pending]: (state) => {
      return {
        ...state,
        onboarding: {
          ...state.onboarding,
          isLoading: true,
        },
      }
    },
  },
})

export const getUserData = (state: any) => state.UserSignIn.userInfo

export const getUserOnboardingData = (state: any) => {
  return state.UserSignIn.onboarding
}

export const {
  logout,
  EmailVerify,
  SignupForm,
  UpdateLoggedUserInfo,
  otpVerified,
  updateOnboardingStatus,
} = UserLoginSlice.actions

export default UserLoginSlice.reducer
